<template>
  <div class="apply-form">
    <!-- 提交订单详情开始 -->
    <template>
      <div class="common-people">
        <div class="hint">请填写真实信息</div>
        <router-link class="label" :to="{ path: '/user/add_manage' }"
          >常用人</router-link
        >
      </div>
      <div class="common-people-add-list">
        <div
          class="common-people-item"
          v-for="(commonPeople, index) in commonPeoples"
          :key="index"
        >
          <div class="common-people-item-left">
            <yd-cell-item
              :class="{ 'error-field': commonPeople.real_name_error }"
            >
              <span slot="left">真实姓名</span>
              <span slot="right"
                ><input
                  v-model="commonPeople.real_name"
                  placeholder="与证件一致"
                  @change="validateCommonPeoples"
              /></span>
            </yd-cell-item>
            <yd-cell-item
              :class="{ 'error-field': commonPeople.id_number_error }"
            >
              <span slot="left">
                <div class="select-box">
                  <select v-model="commonPeople.id_type">
                    <option
                      v-for="(cardType, index) in cardTypes"
                      :value="cardType.value"
                      :key="index"
                      >{{ cardType.name }}</option
                    >
                  </select>
                  <i></i>
                </div>
              </span>
              <span slot="right">
                <input
                  v-model="commonPeople.id_number"
                  @change="validateCommonPeoples"
                  placeholder="与证件一致"
                />
              </span>
            </yd-cell-item>
            <yd-cell-item :class="{ 'error-field': commonPeople.phone_error }">
              <span slot="left">电话号码</span>
              <span slot="right">
                <input
                  v-model="commonPeople.phone"
                  placeholder="(必填)"
                  @change="validateCommonPeoples"
                />
              </span>
            </yd-cell-item>
            <!--            <yd-cell-item>-->
            <!--              <span slot="left">生日</span>-->
            <!--              <span slot="right">-->
            <!--                <DateTime-->
            <!--                  type="date"-->
            <!--                  v-if="commonPeople.birthday != null"-->
            <!--                  class="right-item"-->
            <!--                  start-date="1920-01-01"-->
            <!--                  v-model="commonPeople.birthday"-->
            <!--                  :callback="orderComputedPrice"-->
            <!--                />-->
            <!--              </span>-->
            <!--            </yd-cell-item>-->
            <yd-cell-item>
              <span slot="left">性别</span>
              <span slot="right" class="right-item" style="width: 127px;">
                <RadioGroup
                  class="radio-group"
                  v-model="commonPeople.sex"
                  required
                >
                  <Radio val="0">男</Radio>
                  <Radio val="1">女</Radio>
                </RadioGroup>
              </span>
            </yd-cell-item>
            <yd-cell-item>
              <span slot="left">身高</span>
              <span
                slot="right"
                class="right-item"
                style="width: 150px; padding: 5px 0; line-height: 25px;"
              >
                <RadioGroup
                  class="radio-group"
                  v-model="commonPeople.height_type"
                  required
                  :callback="orderComputedPrice"
                >
                  <Radio
                    :val="value"
                    v-for="(text, value) in heightType"
                    :key="value"
                    >{{ text }}</Radio
                  >
                </RadioGroup>
              </span>
            </yd-cell-item>
            <!-- <yd-cell-item>
              <span slot="left">
                交通方式
              </span>
              <span slot="right">
                <div class="select-box traffic">
                  <select v-model="commonPeople.trade" class="traffic-tools">
                    <option
                      v-for="(trafficTool, index) in trafficTools"
                      :value="trafficTool.value"
                      :key="index"
                      >{{ trafficTool.name }}</option
                    >
                  </select>
                  <i></i>
                </div>
              </span>
            </yd-cell-item> -->
          </div>
          <div class="common-people-item-right">
            <div
              class="common-people-btn"
              @click="addMember()"
              v-if="index === 0"
            >
              +
            </div>

            <div
              class="common-people-btn minus-people-btn"
              @click="removeMember(index)"
              v-if="index !== 0"
            >
              -
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
      <yd-cell-group title="当前选择">
        <yd-cell-item>
          <span slot="left">{{ cityName }}出发</span>
          <span slot="right">{{ dateCn }}</span>
        </yd-cell-item>
      </yd-cell-group>
      <yd-cell-group title="费用详情">
        <yd-cell-item v-if="person_num.adult > 0">
          <span slot="left"
            ><template v-if="person_num.child > 0 || person_num.baby > 0"
              >成人</template
            >价格 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          </span>
          <span class="avg-wrapper" slot="right">
            <b class="avg"
              ><i class="green">{{ detail.price }}</i
              >元</b
            >
            <b class="avg"
              >数量<i class="green">{{ person_num.adult }}</i></b
            >
          </span>
        </yd-cell-item>
        <yd-cell-item v-if="person_num.child > 0">
          <span slot="left">1.2米以上儿童</span>
          <span class="avg-wrapper" slot="right">
            <b class="avg"
              ><i class="green">{{ detail.price_child }}</i
              >元</b
            >
            <b class="avg"
              >数量<i class="green">{{ person_num.child }}</i></b
            >
          </span>
        </yd-cell-item>
        <yd-cell-item v-if="person_num.baby > 0">
          <span slot="left">1.2米以下儿童</span>
          <span class="avg-wrapper" slot="right">
            <b class="avg"
              ><i class="green">{{ detail.price_baby }}</i
              >元</b
            >
            <b class="avg"
              >数量<i class="green">{{ person_num.baby }}</i></b
            >
          </span>
        </yd-cell-item>
      </yd-cell-group>

      <yd-cell-group title="支付方式">
        <yd-cell-item
          v-for="(payment, index) in payments"
          :key="index"
          @click.native="selectedPayment = payment.value"
        >
          <span slot="left">{{ payment.name }}</span>
          <span
            slot="right"
            class="travel-list-radio"
            :class="payment.value === selectedPayment ? 'checked' : ''"
          >
            <b><i></i></b>
          </span>
        </yd-cell-item>
      </yd-cell-group>

      <yd-cell-group title="优惠抵扣">
        <yd-cell-item>
          <span slot="left">使用积分余额抵扣</span>
          <span slot="right"
            ><i v-if="useIntegral">扣减-{{ deductionPrice }}元</i
            >&nbsp;&nbsp;<yd-checkbox
              class="no-padd-right"
              @click.native="useIntegralFun"
              ><i></i></yd-checkbox
          ></span>
        </yd-cell-item>
        <!-- <yd-cell-item>
          <span slot="left">星币抵扣</span>
          <span slot="right" class="color-red">当前星币0，满100星币起抵扣</span>
        </yd-cell-item> -->
        <yd-cell-item arrow @click.native="showUserCoupons">
          <span slot="left">代金券</span>
          <span slot="right" class="color-red">
            <template v-if="!selectedCoupon.coupon_title">
              你有{{ couponsList.length }}张卡券
            </template>
            <template v-else>
              {{ selectedCoupon.coupon_title }}
            </template>
          </span>
        </yd-cell-item>
      </yd-cell-group>

      <!-- <div class="agree-protocal">
        <yd-checkbox v-model="agreeProtocal" class="no-padd-right"
          ><i></i
        ></yd-checkbox>
        <span
          >我已阅读并同意<a>《旅游服务协议》</a>以及<a
            >《费用须知及退款规则》</a
          ></span
        >
      </div> -->
      <div class="margin-bottom-holder" style="margin-bottom: 150px;"></div>
      <div class="payment-bottom-btns">
        <div class="price-detail">
          <div class="bigger red">
            支付：<i>{{ payPrice }}元</i>
          </div>
          <div>
            总费用：<i>{{ totalFee }}元</i>
          </div>
          <div v-if="couponPrice > 0">
            优惠券扣减：<i>-{{ couponPrice }}元</i>
          </div>
          <div v-if="deductionPrice > 0">
            积分扣减：<i>-{{ deductionPrice }}元</i>
          </div>
        </div>
        <a class="payment-btn" @click="submitOrder">提交订单</a>
      </div>
    </template>
    <!-- 提交订单详情开始 -->

    <!-- 优惠券选择弹框开始 -->
    <Popup v-model="couponDialogShow">
      <div class="coupon-popup">
        <h3 class="coupon-tip">
          选中后再次点击可取消优惠券, 点击灰色区域取消此次操作
        </h3>
        <div class="coupon-list" v-if="couponsList.length > 0">
          <div
            class="item acea-row row-center-wrapper"
            v-cloak
            v-for="(item, index) in couponsList"
            :key="index"
            @click="selectCoupon(item)"
          >
            <div class="money" :class="item._type === 0 ? 'moneyGray' : ''">
              ￥<span class="num">{{ item.coupon_price }}</span>
            </div>
            <div class="text">
              <div class="condition line1">{{ item.coupon_title }}</div>
              <div class="data acea-row row-between-wrapper">
                <div v-if="item._end_time === 0">不限时</div>
                <div v-else>{{ item._add_time }}-{{ item._end_time }}</div>
                <div class="bnt gray" v-if="item._type === 0">
                  {{ item._msg }}
                </div>
                <div class="bnt bg-color-red" v-else>{{ item._msg }}</div>
              </div>
            </div>
          </div>
        </div>
        <!--暂无优惠券-->
        <div
          class="noCommodity"
          v-if="couponsList.length === 0 && loading === true"
        >
          <div class="noPictrue">
            <img src="@assets/images/noCoupon.png" class="image" />
          </div>
        </div>
      </div>
    </Popup>
    <!-- 优惠券选择弹框结束 -->
  </div>
</template>
<script>
import { CellGroup, CellItem } from "vue-ydui/dist/lib.rem/cell";
import { Radio, RadioGroup } from "vue-ydui/dist/lib.rem/radio";
import { Popup } from "vue-ydui/dist/lib.rem/popup";
import { CheckBox } from "vue-ydui/dist/lib.rem/checkbox";
import { getAddressList } from "@api/user";
// import { DateTime } from "vue-ydui/dist/lib.rem/datetime";
import { getActivityDetail } from "@api/activity";
import {
  postOrderComputed,
  activityOrderConfirm,
  createOrder
} from "@api/order";
import { payOrderHandle } from "@libs/order";
import { isWeixin } from "@utils";
import dayjs from "dayjs";

export default {
  data() {
    return {
      payment: "",
      detail: {},
      totalFee: 0,
      payPrice: 0,
      couponPrice: 0,
      deductionPrice: 0,
      person_num: {
        adult: 1,
        child: 0,
        baby: 0
      },
      heightType: {
        adult: "成年人",
        child: "1米2以上未成年",
        baby: "1米2以下未成年"
      },
      cardTypes: [
        {
          name: "身份证",
          value: 0
        },
        {
          name: "港澳通行证",
          value: 1
        },
        {
          name: "中国护照",
          value: 2
        },
        {
          name: "香港护照",
          value: 3
        },
        {
          name: "澳门护照",
          value: 4
        },
        {
          name: "回乡证",
          value: 5
        },
        {
          name: "台胞证",
          value: 6
        },
        {
          name: "其他证件",
          value: 7
        }
      ],
      trafficTools: [
        // {
        //   name: "请您选择",
        //   value: 0
        // },
        // {
        //   name: "去程火车回程高铁(默认)",
        //   value: 1
        // },
        // {
        //   name: "儿童票（1.2-1.5m） -293元",
        //   value: 2
        // },
        // {
        //   name: "往返自理 -709元",
        //   value: 3
        // }
      ],
      commonPeoples: [
        {
          real_name: "",
          phone: "",
          id_type: 0,
          id_number: "",
          // birthday: "1980-01-01",
          height_type: "adult"
        }
      ],
      payments: [
        {
          name: "微信",
          value: "weixin"
        },
        {
          name: "余额",
          value: "yue"
        }
      ],
      selectedPayment: "weixin",
      deduction: false,
      agreeProtocal: false,
      dateCn: "",
      cityName: "",
      commonPeoplePageIndex: 1,
      commonPeoplePageSize: 500,
      couponsList: [],
      couponDialogShow: false,
      selectedCoupon: {},
      useIntegral: false,
      userIntegral: 0,
      orderKey: "",
      from: isWeixin() ? "weixin" : "weixinh5"
    };
  },
  components: {
    [CellGroup.name]: CellGroup,
    [CellItem.name]: CellItem,
    [CheckBox.name]: CheckBox,
    Radio,
    RadioGroup,
    // DateTime,
    Popup
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.id = parseInt(this.$route.query.id);
      this.cityId = parseInt(this.$route.query.city_id);
      this.timeId = parseInt(this.$route.query.time_id);
      this.dateCn = this.$route.query.date_cn;
      this.cityName = this.$route.query.city_name;
      this.loadDetail();
      this.loadOrderConfirmDetail();
    },
    addMember() {
      this.commonPeoples.push({
        real_name: "",
        id_number: "",
        phone: "",
        // birthday: "1980-01-01",
        sex: 0,
        id_type: 0,
        height_type: "adult"
      });
      this.orderComputedPrice();
    },
    removeMember(index) {
      this.commonPeoples.splice(index, 1);
      this.orderComputedPrice();
    },
    loadOrderConfirmDetail() {
      activityOrderConfirm({
        product_id: this.id,
        time_id: this.timeId,
        city_id: this.cityId
      }).then(res => {
        const usableCoupon = [res.data.usableCoupon];
        this.userIntegral = res.data.userInfo.integral;
        this.commonPeoples = res.data.addressInfo
          ? [res.data.addressInfo]
          : this.commonPeoples;
        this.orderKey = res.data.orderKey;

        if (res.data.usableCoupon) {
          this.couponsList = usableCoupon.map(elem => ({
            ...elem,
            ...{
              _msg: "可使用",
              _type: 1,
              _add_time: dayjs(elem.add_time * 1000).format("YYYY年MM月DD日"),
              _end_time: dayjs(elem.end_time * 1000).format("YYYY年MM月DD日")
            }
          }));
        }
        this.orderComputedPrice();
      });
    },
    loadCommonPeoples() {
      getAddressList({
        page: this.commonPeoplePageIndex,
        limit: this.commonPeoplePageSize
      })
        .then(res => {
          if (res.data && res.data.length) {
            let commonPeoples = res.data;
            // 选择默认常用人为第一个活动常用人如果一个默认的都没有则用第一个作为活动常用人
            const defaultPeoples = commonPeoples.filter(
              item => item.is_default === 1
            );
            if (defaultPeoples.length > 1) {
              commonPeoples = defaultPeoples;
            } else {
              commonPeoples = [commonPeoples[0]];
            }
            this.commonPeoples = commonPeoples;
            this.orderComputedPrice();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    showUserCoupons() {
      this.couponDialogShow = true;
    },
    selectCoupon(item) {
      this.couponsList = this.couponsList.map(elem => {
        if (elem.id === item.id) {
          if (elem._type === 1) {
            elem._type = 0;
            this.selectedCoupon = elem;
          } else {
            elem._type = 1;
            this.selectedCoupon = {};
          }
        } else {
          elem._type = 1;
        }
        return elem;
      });
      this.orderComputedPrice();
    },
    orderComputedPrice() {
      if (!this.orderKey) {
        return false;
      }
      this.$dialog.loading.open();
      postOrderComputed(this.orderKey, {
        couponId: this.selectedCoupon.id,
        person_info: this.commonPeoples,
        useIntegral: this.useIntegral ? 1 : 0,
        productType: "activity"
      })
        .then(res => {
          this.$dialog.loading.close();
          this.totalFee = res.data.result.total_price;
          this.payPrice = res.data.result.pay_price;
          this.couponPrice = res.data.result.coupon_price;
          this.deductionPrice = res.data.result.deduction_price;
          this.person_num.adult = res.data.result.num_adult;
          this.person_num.child = res.data.result.num_child;
          this.person_num.baby = res.data.result.num_baby;
        })
        .catch(e => {
          this.$dialog.loading.close();
          this.$dialog.toast({
            mes: e.msg ? e.msg : "计算订单错误" + e.message
          });
        });
    },
    loadDetail() {
      this.$dialog.loading.open();
      getActivityDetail(this.id, {
        city_id: this.cityId,
        time_id: this.time_id
      })
        .then(res => {
          this.$dialog.loading.close();
          // let applyCount = 0;
          this.detail = res.data.storeInfo;
        })
        .catch(err => {
          this.$dialog.loading.close();
          this.$dialog.error(err.msg ? err.msg : "获取活动介绍失败!");
        });
    },
    validateCommonPeoples() {
      let validate = true;
      this.commonPeoples = this.commonPeoples.map(elem => {
        elem.real_name_error = false;
        elem.id_number_error = false;
        elem.phone_error = false;
        if (!elem.real_name) {
          elem.real_name_error = "真实姓名必须";
          validate = false;
        }
        if (!elem.id_number) {
          elem.id_number_error = "证件号码必须";
          validate = false;
        }
        if (!elem.phone) {
          elem.phone_error = "电话号码是必须的";
          validate = false;
        }
        return elem;
      });
      return validate;
    },
    useIntegralFun(e) {
      if (e.target.tagName === "INPUT") return;
      this.useIntegral = !this.useIntegral;
      this.orderComputedPrice();
    },
    submitOrder() {
      const type = this.selectedPayment;
      const orderId = this.orderKey;
      if (this.validateCommonPeoples() === false) {
        return this.$dialog.error("请检查输入项");
      }
      this.$dialog.loading.open();
      createOrder(orderId, {
        couponId: this.selectedCoupon.id,
        person_info: this.commonPeoples,
        useIntegral: this.useIntegral ? 1 : 0,
        payType: this.selectedPayment
      })
        .then(res => {
          console.log(res);
          if (res.status === 200 && res.data.status === "SUCCESS") {
            this.$dialog.toast({ mes: "支付成功" });
            this.$dialog.loading.close();
            return this.$router.push({
              path: "/order/status/" + orderId + "/1"
            });
          }
          payOrderHandle(orderId, type, this.from)
            .then(() => {
              this.$dialog.toast({ mes: "支付成功" });
              this.$dialog.loading.close();
              return this.$router.push({
                path: "/order/status/" + orderId + "/1"
              });
            })
            .catch(err => {
              this.$dialog.error("支付失败！" + err.message);
              this.$dialog.loading.close();
              if (res.status === "WECHAT_H5_PAY")
                return this.$router.push({
                  path: "/order/status/" + orderId + "/5"
                });
            });
        })
        .catch(err => {
          this.$dialog.loading.close();
          this.$dialog.error(
            err.msg ? err.msg : "创建订单失败！" + err.message
          );
        });
    }
  },
  watch: {
    $route() {
      this.init();
    }
  }
};
</script>
